import classNames from 'classnames';
import React from 'react';
import { Col, Row } from 'reactstrap';
import { EmptyTab } from '../../../../../components/EmptyTab';
import { ProgressBar } from '../../../../../components/ProgressBar';
import { InterviewQuestion } from '../../../../../entities/InterviewQuestion';
import UndrawLost from '../../../../../images/undraw_lost_re_xqjt.svg';
import { CommonListPanel } from '../../CommonListPanel';
import { InterviewQuestionPart } from './InterviewQuestionPart';

interface PropTypes {
  interviewQuestions: InterviewQuestion[];
  onInterviewQuestionsUpdated: (question: InterviewQuestion) => void;
}

function QuestionsEmptyState() {
  return (
    <div className='px-5'>
      <EmptyTab
        title={'No questions available yet'}
        text={
          'Improve your experience by adding questions to help guide you through the interview.'
        }
        imageSrc={UndrawLost}
        size={'medium'}
      />
    </div>
  );
}

function QuestionsHeader(props: { interviewQuestions: InterviewQuestion[] }) {
  const questionsNumber: number = props.interviewQuestions.length;
  const questionsCheckedNumber: number = props.interviewQuestions.filter(
    (iq) => iq.selected,
  ).length;

  return (
    <Row className='justify-content-between'>
      <Col>
        <h2 className={classNames('ms-3', 'mb-3', 'fs-4')}>
          Interview Questions
        </h2>
      </Col>
      <Col className='me-3'>
        {questionsNumber !== 0 && (
          <ProgressBar
            justifyContentClass='justify-content-end'
            label={`(${questionsCheckedNumber}/${questionsNumber})`}
            progress={(questionsCheckedNumber / questionsNumber) * 100.0}
            labelClasses='fs-6 text-dark-200'
            progressBarColorClass='bg-success-500'
          />
        )}
      </Col>
    </Row>
  );
}

export function InterviewQuestionsPanel(props: PropTypes) {
  return (
    <CommonListPanel
      header={<QuestionsHeader interviewQuestions={props.interviewQuestions} />}
    >
      {props.interviewQuestions.length > 0 ? (
        <div className='form-check ms-3' id='interview_questions'>
          {props.interviewQuestions.map((interviewQuestion) => (
            <InterviewQuestionPart
              key={interviewQuestion.id}
              interviewQuestion={interviewQuestion}
              onInterviewQuestionsUpdated={props.onInterviewQuestionsUpdated}
            />
          ))}
        </div>
      ) : (
        <QuestionsEmptyState />
      )}
    </CommonListPanel>
  );
}
